import React from "react";
import {Container, Typography,} from "@mui/material";
import ClientForm from "../../components/ClientForm";
import {api} from "../../services/apiService";

import {useNavigate} from "react-router-dom";

export default function ClientAdd() {
    const navigate = useNavigate();

    const handleSubmit = (data) => {
        const request = api.post("/clients/add", data)
            .then(() => {
                navigate("/clients");
            })
            .catch(error => {
                console.error("Error adding client:", error);
            });

        return request;
    }

    return (
        <Container maxWidth="xl">
            <Typography variant="h1" gutterBottom sx={{mb: 4}}>
                Ajouter un client
            </Typography>

            <ClientForm onSubmit={handleSubmit}/>
        </Container>
    );
}

